//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from "vuex";
import Theme from "@/listing-app/mixins/Theme";
import ExpandTransition from "@/listing-app/components/ExpandTransition";

export default {
  name: "MultiSelect",
  mixins: [Theme],
  props: ["data"],
  components: {
    appExpandTransition: ExpandTransition
  },
  data() {
    return {
      open: false
    };
  },
  computed: {
    ...mapGetters(["read"]),
    selectedText() {
      let selections = this.read("filters")[this.data.ID];
      return selections[0].text;
    },
    selectedCount() {
      return this.read("filters")[this.data.ID].length > 1
        ? this.read("filters")[this.data.ID].length
        : false;
    },
    selectedValues() {
      return this.read("filters")[this.data.ID];
    }
  },
  methods: {
    ...mapActions(["set"]),
    init() {
      if (!this.read("filters").hasOwnProperty(this.data.ID)) {
        let defaultAvailable = false;
        let multi = this.data.Values.reduce((_multi, option) => {
          if (option.hasOwnProperty("Default") && option.Default == true) {
            defaultAvailable = true;
            _multi.push({ value: option.ID, text: option.Text });
          }
          return _multi;
        }, []);

        if (defaultAvailable) {
          this.update_selection(multi);
        } else {
          this.update_selection([
            {
              value: this.data.Values[0].ID,
              text: this.data.Values[0].Text
            }
          ]);
        }
      }
    },
    update_selection(options) {
      let filter = this.data.ID;
      let multi = {};

      if (!Array.isArray(options)) {
        multi.value = options.ID;
        multi.text = options.Text;
      } else {
        multi = options;
      }

      this.set({ muta: "filters", data: { filter, multi } });
    },
    toggle() {
      this.open = !this.open;
    },
    click(e) {
      if (e.type == "click") {
        if (e.target.closest(".multiselect") != this.$el) {
          this.open = false;
        }
      } else if (e.type == "keyup") {
        if (e.target.closest(".multiselect") != this.$el) {
          this.open = false;
        }
        if (
          e.target.closest(".multiselect") == this.$el &&
          e.code == "Escape"
        ) {
          this.open = false;
        }
      }
    }
  },
  created() {
    this.init();
    window.addEventListener("click", this.click);
    window.addEventListener("keyup", this.click);
  },
  beforeDestroy() {
    window.removeEventListener("click", this.click);
    window.addEventListener("keyup", this.click);
  }
};
